import { Config } from "./configTypes";

export const buildMalaysiaConfig = async (): Promise<Config> => {
  // Config
  const configs = {
    baseUrl: (window as any)?.env?.baseUrl || process.env.REACT_APP_API_URL,
    depositUrl:
      (window as any)?.env?.depositUrl || process.env.REACT_APP_DEPOSIT_URL,
  };

  return {
    siteTitle: "Trive Malaysia",
    whatsappUrl: process.env.REACT_APP_WHATSAPP_NUMBER,

    company: {
      COMPANY_ID: Number(process.env.REACT_APP_COMPANY_ID) || 0,
      SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || "",
      FAQ_URL: process.env.REACT_APP_FAQ_REDIRECT_URL || "",
    },

    api: {
      API_URL: configs.baseUrl,
      DEPOSIT_URL: configs.depositUrl,
    },
  };
};
